import type { SVGProps } from 'react';
import * as React from 'react';

const SvgCart24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6 7h14l-2 7.5H8zM6 7l-.5-2H3"
    />
    <circle
      cx={8.5}
      cy={18.5}
      r={1.5}
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <circle
      cx={17.5}
      cy={18.5}
      r={1.5}
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgCart24;
